import { STATIC_IMAGE_URLS } from 'modules/core/constants';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../common';
import {
  LoginContent,
  PositionCard,
  CardForm,
  CardImage,
  CardTitle,
  TextForgotPassword,
  LoginHeader,
  HeaderLogo,
  DecorativeLayer,
  BackgroundLayer,
  CardBody,
  CreatePasswordSuccessPosition,
} from '../styles';
import { CreatePasswordForm } from './CreatePasswordForm';

const { logoDark, logoWhite } = STATIC_IMAGE_URLS;

export const CreatePassword: React.FC = () => {
  const { t } = useTranslation();
  const [successChangedPassword, setSuccessChangedPassword] = useState(false);

  const showCongratulationsContent = useCallback(() => {
    setSuccessChangedPassword(true);
  }, []);

  return (
    <>
      <LoginHeader>
        <HeaderLogo src={logoWhite} alt="Streamline Logo" />
      </LoginHeader>
      <BackgroundLayer />
      <DecorativeLayer />
      <LoginContent>
        <PositionCard>
          <CardForm>
            <CardImage src={logoDark} />
            {successChangedPassword ? (
              <CardBody>
                <CreatePasswordSuccessPosition>
                  <CardTitle>{t('components.createPassword.allSet')}</CardTitle>
                  <TextForgotPassword>
                    {t('components.createPassword.passwordChanged')}
                    <div>&nbsp;</div>
                    {t('components.createPassword.emailConfirmInfo')}
                  </TextForgotPassword>
                  <Button label={t('components.login.buttons.backToLogin')} isOnClick />
                </CreatePasswordSuccessPosition>
              </CardBody>
            ) : (
              <CardBody>
                <CreatePasswordForm onShowCongratulationsContent={showCongratulationsContent} />
              </CardBody>
            )}
          </CardForm>
        </PositionCard>
      </LoginContent>
    </>
  );
};
